<vi-page [sidenavs]="true" [footer]="true">
  <vi-content body>
    <vi-panel main [title]="'Pill'">
      <div class="content" content>
        <div class="singular-pill">
          <p>Informationall pills</p>
          <app-pill [type]="pillType.brand"> Brand </app-pill>
          <app-pill [type]="pillType.brandInverted"> Brand Inverted </app-pill>
          <app-pill [type]="pillType.primary"> Maintenance </app-pill>
          <app-pill [type]="pillType.info"> Remote diagnostic </app-pill>
          <app-pill [type]="pillType.infoInverted"> Info inverted </app-pill>
          <app-pill [type]="pillType.medium"> Caution </app-pill>
          <app-pill [type]="pillType.mediumInverted"> Caution </app-pill>
        </div>
        <div class="singular-pill">
          <p>Warning pills</p>
          <app-pill [type]="pillType.warning"> Warning </app-pill>
          <app-pill [type]="pillType.warningInverted"> Warning inverted </app-pill>
        </div>
        <div class="singular-pill">
          <p>Error pills</p>
          <app-pill [type]="pillType.error"> Error </app-pill>
          <app-pill [type]="pillType.errorInverted"> Critical </app-pill>
          <app-pill [type]="pillType.errorInverted"> Locked system </app-pill>
        </div>
        <div class="singular-pill">
          <p>Neutral pills</p>
          <app-pill [type]="pillType.neutral"> Neutral </app-pill>
          <app-pill [type]="pillType.neutralInverted">Neutral Inverted </app-pill>
        </div>
        <div class="singular-pill">
          <p>Working fine</p>
          <app-pill [type]="pillType.success"> Working </app-pill>
          <app-pill [type]="pillType.successInverted"> Success inverted </app-pill>
        </div>

        <div class="singular-pill">
          <p>Inactive section</p>

          <app-pill [type]="pillType.secondary"> Offline </app-pill>
          <app-pill [type]="pillType.secondaryInverted"> NBiot </app-pill>
        </div>
        <div class="singular-pill">
          <p>Feature pill</p>
          <app-pill [type]="pillType.bright"> Active </app-pill>
          <app-pill [type]="pillType.dark"> Inactive </app-pill>
        </div>
        <div class="singular-pill">
          <p>Form</p>
          <app-pill [type]="pillType.errorInverted"> Canceled invitation</app-pill>
        </div>
      </div>
    </vi-panel>
  </vi-content>
</vi-page>
